import { Component, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DeviceSettingFormComponent } from '../device-setting-form/device-setting-form.component';

@Component({
  selector: 'app-device-setting-modal',
  templateUrl: './device-setting-modal.component.html',
  styleUrls: ['./device-setting-modal.component.css']
})
export class DeviceSettingModalComponent {
  @ViewChild('formComponent') formComponent: DeviceSettingFormComponent;

  constructor(public activeModal: NgbActiveModal) { }

  save() {
    this.formComponent.save();
  }

  openPrinterSetting() {
    this.formComponent.openPrinterSetting();
  }

  close() {
    this.activeModal.close();
  }
}
